import { Cubby } from "../stores/Cubby";
import { Rizvoice } from "../stores/Rizvoice";

const convertSatsToBTC = (sats: number) => {
  return sats / 100_000_000;
};

export const convertSatsToFiatString = (
  sats: number,
  cubby: Cubby | Rizvoice,
  truncateCentsIfHighInteger = false
) => {
  const euroExchangeRate = cubby.environmentData.data.btc_eur_price;
  const usdExchangeRate = cubby.environmentData.data.btc_usd_price;

  const convertToFiat = (exchangeRate: number) =>
    convertSatsToBTC(Math.abs(sats)) * exchangeRate; // Use Math.abs to make sats positive

  const formatFiat = (amount: number, currencySymbol: string) => {
    if (amount < 0.01 && amount > -0.01 && amount !== 0) {
      return `${currencySymbol}0.01`;
    }

    const integerPart = Math.floor(amount); // Get the integer part of the amount
    const options =
      truncateCentsIfHighInteger && integerPart > 999
        ? { minimumFractionDigits: 0, maximumFractionDigits: 0 } // Truncate cents
        : { minimumFractionDigits: 2, maximumFractionDigits: 2 }; // Keep cents

    return currencySymbol + amount.toLocaleString(undefined, options);
  };

  if (cubby.useUsdForFiat) {
    const amountInUsd = convertToFiat(usdExchangeRate);
    return formatFiat(amountInUsd, "$");
  } else {
    const amountInEur = convertToFiat(euroExchangeRate);
    return formatFiat(amountInEur, "€");
  }
};

export const convertSatsToFiatStringRoundedToNearestFifty = (
  sats: number,
  cubby: Cubby
) => {
  const euroExchangeRate = cubby.environmentData.data.btc_eur_price;
  const usdExchangeRate = cubby.environmentData.data.btc_usd_price;
  if (cubby.useUsdForFiat) {
    return (
      "$" +
      (
        Math.round((convertSatsToBTC(sats) * usdExchangeRate) / 50) * 50
      ).toLocaleString()
    );
  } else {
    return (
      "€" +
      (
        Math.round((convertSatsToBTC(sats) * euroExchangeRate) / 50) * 50
      ).toLocaleString()
    );
  }
};

// new function that does the same as above but rounds to the nearest whole number

export const convertSatsToFiatStringRoundedToNearestWhole = (
  sats: number,
  cubby: Cubby
) => {
  const euroExchangeRate = cubby.environmentData.data.btc_eur_price;
  const usdExchangeRate = cubby.environmentData.data.btc_usd_price;
  if (cubby.useUsdForFiat) {
    return "$" + Math.round(convertSatsToBTC(sats) * usdExchangeRate);
  } else {
    return "€" + Math.round(convertSatsToBTC(sats) * euroExchangeRate);
  }
};

export const showBtcAmount = (sats: number, cubby: Cubby) => {
  if (cubby.useSatoshisForBtc) {
    return sats.toLocaleString() + " sats";
  } else {
    return convertSatsToBTC(sats).toFixed(8) + " BTC";
  }
};
